import Vue from 'vue'
import Vuex from 'vuex'
import server from './server'
import JWT from 'jsonwebtoken'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentToken: localStorage.getItem('qidtoken')
  },
  mutations: {
    login (state, data) {
      state.currentToken = data
    },
    logout (state) {
      state.currentToken = null
    }
  },
  actions: {
    login ({ commit }, credentials) {
      return server.post('/login', { email: credentials.email, password: credentials.password })
        .then(res => {
          commit('login', res.data.token)
          localStorage.setItem('qidtoken', res.data.token)
          return res
        })
    },
    logout ({ commit }) {
      localStorage.removeItem('qidtoken')
      commit('logout')
    }
  },
  getters: {
    currentToken: state => {
      return state.currentToken
    },
    currentUser: state => {
      let userData = JWT.decode(state.currentToken)
      if (userData) {
        return {
          id: userData.sub,
          fullName: userData.full_name,
          email: userData.email,
          role: userData.role
        }
      }
      return null
    },
    currentRole: (state, getters) => {
      let userData = getters.currentUser
      if (!userData) { return null }
      return userData.role
    },
    isAdmin: (state, getters) => {
      return getters.currentRole === 'admin'
    },
    isOperator: (state, getters) => {
      return getters.currentRole === 'operator'
    },
    isCustomer: (state, getters) => {
      return getters.currentRole === 'customer'
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js